// extracted by mini-css-extract-plugin
module.exports = {"moreOptionsPopover":"MoreOptions_moreOptionsPopover__nXgko","divider":"MoreOptions_divider__qEYpE","customOption":"MoreOptions_customOption__24U0M"};